import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgElite = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.0225 19.9647L12.0034 17.3943C11.9234 17.3516 11.8327 17.3463 11.7527 17.3943L6.64821 19.7941C6.45085 19.9007 6.2215 19.7194 6.26417 19.4901L7.75231 14.2425C7.76831 14.1519 7.74164 14.0612 7.67763 13.9919L4.0773 10.2002C3.92262 10.0349 4.0133 9.75225 4.23199 9.72558L9.30978 9.04831C9.39512 9.03764 9.47513 8.97898 9.51247 8.89898L11.8593 4.15271C11.9607 3.94473 12.2434 3.95006 12.3394 4.16338L14.5849 9.1283L19.7747 10.0136C19.9934 10.0509 20.0788 10.3335 19.9134 10.4935L16.1851 14.1519C16.1211 14.2159 16.0891 14.3065 16.1051 14.3972L17.4172 19.6768C17.4492 19.9061 17.2198 20.0767 17.0225 19.9647Z",
		stroke: "#2C2C27",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgElite;
